





















import { Component, Prop, Vue } from 'vue-property-decorator';

import Tooltip from './Tooltip.vue';

@Component({
  name: 'field',
  components: { Tooltip }
})
export default class FieldComponent extends Vue {
  @Prop({ default: '' }) public label!: string;
  @Prop({ default: () => [] }) public errorMessages!: string[];
  @Prop({ type: Boolean, default: false }) public required!: boolean;
  @Prop({ default: '' }) public tooltip!: string;
  @Prop() public tooltipWidth!: number | undefined;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;
  @Prop({ type: Boolean, default: false }) public noFieldBorder!: boolean;

  public get errors(): boolean { return this.errorMessages.length > 0; }
}
